import { Outlet } from "react-router-dom";
import styles from './style.module.scss'
import Background from "../../../components/Flourish/background";

export default function LoginLayout() {

  return (
    <>
      <div className={styles.loginWrapper}>
        <Outlet />
      </div>
      <Background />
    </>
  )
}
